import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus, faTrain, faPersonWalking, faMapMarkedAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import './RouteDetailsTransitList.css';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const RouteDetailsTransitList = ({
  from,
  to,
  overlayData,
  handleRouteCardClick,
  setShowDepartPopup,
  setShowFilterPopup,
  loading,
  error,
  closeOverlay
}) => {
  const renderTransitIcon = (leg) => {
    const renderTransitBadge = (transitLine) => {
      if (!transitLine?.shortName) return null;
      
      return (
        <span 
          className="transit-badge"
          style={{
            backgroundColor: transitLine.color || '#000000',
            color: transitLine.textColor || '#ffffff'
          }}
        >
          {transitLine.shortName}
        </span>
      );
    };

    if (leg.travelMode === 'TRANSIT') {
      if (leg?.transitLine?.vehicle?.iconUrl) {
        return (
          <div className="transit-container">
            <img 
              src={leg.transitLine.vehicle.iconUrl} 
              alt={leg.transitLine.vehicle.type || 'Transit'} 
              className="transit-icon"
            />
            {renderTransitBadge(leg.transitLine)}
          </div>
        );
      }

      return (
        <div className="transit-container">
          <FontAwesomeIcon 
            icon={leg.transitLine?.vehicle?.type === 'BUS' ? faBus : faTrain} 
            className="transit-icon"
          />
          {renderTransitBadge(leg.transitLine)}
        </div>
      );
    }

    const iconMap = {
      'WALK': faPersonWalking,
      'default': faMapMarkedAlt
    };

    return <FontAwesomeIcon icon={iconMap[leg.travelMode] || iconMap.default} className="transit-icon" />;
  };

  const getCombinedTransportModes = (routeDetails) => {
    if (!routeDetails) return [];
    
    const combinedModes = [];
    let currentMode = null;

    routeDetails.forEach((leg, index) => {
      if (leg.travelMode === 'WALK') {
        if (index === 0 || routeDetails[index - 1].travelMode !== 'WALK') {
          combinedModes.push({
            type: 'WALK',
            leg: leg
          });
        }
      } else {
        combinedModes.push({
          type: leg.travelMode,
          leg: leg
        });
      }
    });

    return combinedModes;
  };

  return (
    <div className="overlay">
      <div className="overlay-content">
        <button onClick={closeOverlay} className="close-btn"> <FontAwesomeIcon icon={faArrowLeft} /></button>
        {loading && <div>Loading...</div>}
        {error && <div className="error-message">Error: {error}</div>}
        {overlayData && Array.isArray(overlayData) && (
          <div className="content-padding">
            {/* Header & Filters */}
            <div className="header-container">
              <div className="transport-icons">
                <span className="transport-icon">
                  {renderTransitIcon(overlayData[0]?.routeDetails?.[0])}
                </span>
                <span className="route-title">
                  {from} to {to}
                </span>
              </div>

              <div className="controls-container">
                <div
                  onClick={() => setShowDepartPopup(true)}
                  className="depart-button"
                >
                  <FontAwesomeIcon icon={faMapMarkedAlt} />
                  <span>Depart Now</span>
                </div>

                <div
                  onClick={() => setShowFilterPopup(true)}
                  className="filter-button"
                >
                  <FontAwesomeIcon icon={faFilter} />
                </div>
              </div>
            </div>

            {/* Travel Cards */}
            {overlayData.map((route, idx) => (
              <div
                key={idx}
                onClick={() => handleRouteCardClick(route)}
                className="route-card"
              >
                <div className="route-timing">
                  <span>{route.departureTime}</span>
                  <span>›</span>
                  <span>{route.arrivalTime}</span>
                </div>

                <div className="route-duration">
                  {route.duration} · Arrive at {route.arrivalTime}
                </div>

                <div className="transport-modes">
                  {getCombinedTransportModes(route.routeDetails).map((mode, i, array) => (
                    <span key={i} className="transport-mode-icon">
                      {renderTransitIcon(mode.leg)}
                      {i !== array.length - 1 && (
                        <span className="transport-mode-separator">›</span>
                      )}
                    </span>
                  ))}
                </div>

                <div className="route-footer">
                  <div className="footer-icons">
                    {/* {renderTransitIcon(route.routeDetails?.[0])} */}
                  </div>
                  <div className="fare-container">
                    <div className="fare-amount">MYR {route.fare}</div>
                    <div className="fare-details">
                      One-way, {route.noOfPassenger} passenger
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RouteDetailsTransitList; 